// Waitlist status enum
export enum WaitlistStatus {
  WAITING = 'WAITING',
  NOTIFIED = 'NOTIFIED',
  SEATED = 'SEATED',
  CANCELLED = 'CANCELLED',
  NO_SHOW = 'NO_SHOW'
}

// Campaign status enum
export enum CampaignStatus {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  SENT = 'sent',
  CANCELLED = 'cancelled',
}

// Message channel enum
export enum MessageChannel {
  EMAIL = 'email',
  SMS = 'sms',
  WHATSAPP = 'whatsapp',
}

// Subscription plan enum
export enum SubscriptionPlan {
  FREE = 'free',
  BASIC = 'basic',
  PREMIUM = 'premium',
}

// Subscription status enum
export enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  PAST_DUE = 'past_due',
}

// Campaign recipient status enum
export enum CampaignRecipientStatus {
  PENDING = 'pending',
  SENT = 'sent',
  DELIVERED = 'delivered',
  FAILED = 'failed',
}

// QR code type enum
export enum QRCodeType {
  WAITLIST = 'waitlist',
  PROMOTION = 'promotion',
}

// QR code source enum
export enum QRCodeSource {
  QR_CODE = 'qr_code',
  DIRECT = 'direct',
  WEBSITE = 'website',
  SOCIAL = 'social',
}

// API routes
export const API_ROUTES = {
  AUTH: {
    SIGN_UP: '/auth/sign-up',
    SIGN_IN: '/auth/sign-in',
    SIGN_OUT: '/auth/sign-out',
    RESET_PASSWORD: '/auth/reset-password',
  },
  RESTAURANT: {
    BASE: '/restaurants',
    PROFILE: '/restaurants/profile',
    QR_CODE: '/restaurants/qr-code',
  },
  WAITLIST: {
    BASE: '/waitlist',
    JOIN: '/waitlist/join',
    UPDATE_STATUS: '/waitlist/status',
  },
  CAMPAIGNS: {
    BASE: '/campaigns',
    TEMPLATES: '/campaigns/templates',
    SEND: '/campaigns/send',
  },
  QR_CODES: {
    BASE: '/qr-codes',
    GENERATE: '/qr-codes/generate',
    TRACK: '/qr-codes/track',
  },
}; 